import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Button,
  SearchBox,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHeader,
  TableHeaderCell,
  Spinner,
  Text,
  Badge,
  Card,
} from "@fluentui/react-components";
import { ArrowLeft20Regular, ChevronRight20Regular } from "@fluentui/react-icons";
import "../CSS/GenericList.css";

const SelectCallFlowComponent = ({ CALL_FLOWS }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCallFlows, setFilteredCallFlows] = useState([]);

  useEffect(() => {
    if (CALL_FLOWS) {
      const filtered = CALL_FLOWS.filter((flow) => {
        const query = searchQuery.toLowerCase();
        return (
          flow.id?.toLowerCase().includes(query) ||
          flow.description?.toLowerCase().includes(query) ||
          flow.scope?.toLowerCase().includes(query)
        );
      });
      setFilteredCallFlows(filtered);
    }
  }, [searchQuery, CALL_FLOWS]);

  const handleSelectCallFlow = (callFlow) => {
    // Naviguer vers le formulaire de création avec le callflow sélectionné
    navigate(`/iaagent/new?callFlowId=${callFlow.id}`);
  };

  if (!CALL_FLOWS) {
    return (
      <div className="loading-container">
        <Spinner size="large" label={t("LOADING")} />
      </div>
    );
  }

  return (
    <div className="list-container">
      <div className="list-header">
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon={<ArrowLeft20Regular />}
            appearance="subtle"
            onClick={() => navigate("/iaagent")}
          />
          <div>
            <Text size={600} weight="semibold">
              {t("SELECT_CALL_FLOW")}
            </Text>
            <br />
            <Text size={300} style={{ color: "#666" }}>
              {t("SELECT_CALL_FLOW_FOR_AGENT_AI")}
            </Text>
          </div>
        </div>
        <SearchBox
          placeholder={t("SEARCH_CALL_FLOW")}
          value={searchQuery}
          onChange={(e, data) => setSearchQuery(data?.value || "")}
          className="search-box"
        />
      </div>

      {filteredCallFlows.length === 0 ? (
        <Card style={{ padding: "40px", textAlign: "center" }}>
          <Text>{t("NO_CALL_FLOWS_FOUND")}</Text>
          <br />
          <Text size={300} style={{ color: "#666", marginTop: "10px" }}>
            {t("CREATE_CALL_FLOW_FIRST")}
          </Text>
        </Card>
      ) : (
        <Table className="data-table">
          <TableHeader>
            <TableRow>
              <TableHeaderCell>{t("NAME")}</TableHeaderCell>
              <TableHeaderCell>{t("DESCRIPTION")}</TableHeaderCell>
              <TableHeaderCell>{t("SCOPE")}</TableHeaderCell>
              <TableHeaderCell style={{ width: "100px" }}>{t("ACTION")}</TableHeaderCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredCallFlows.map((callFlow) => (
              <TableRow
                key={callFlow.id}
                style={{ cursor: "pointer" }}
                onClick={() => handleSelectCallFlow(callFlow)}
              >
                <TableCell>
                  <Text weight="semibold">{callFlow.id}</Text>
                </TableCell>
                <TableCell>
                  <Text>{callFlow.description || "-"}</Text>
                </TableCell>
                <TableCell>
                  <Badge appearance="outline">{callFlow.scope}</Badge>
                </TableCell>
                <TableCell>
                  <Button
                    icon={<ChevronRight20Regular />}
                    appearance="subtle"
                    onClick={() => handleSelectCallFlow(callFlow)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default SelectCallFlowComponent;
